import Script from "next/script";
import { faqToFAQPageSchema } from "@/lib/schemas/faq-schemas";
import type { UnifiedFAQItem } from "@/components/UnifiedFAQ";
import type { GeneralFAQItem } from "@/lib/data/faq/general";

interface ToolPageSchemaProps {
  name: string;
  description: string;
  url: string;
  breadcrumbs: Array<{ name: string; url: string }>;
  faq?: UnifiedFAQItem[];
}

export default function ToolPageSchema({
  name,
  description,
  url,
  breadcrumbs,
  faq,
}: ToolPageSchemaProps) {
  const webPageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name,
    description,
    url,
    isPartOf: {
      "@type": "WebSite",
      name: "PlugMonkey",
      url: "https://plugmonkey.xyz",
    },
    publisher: {
      "@type": "OnlineBusiness",
      name: "PlugMonkey",
      url: "https://plugmonkey.xyz",
      logo: {
        "@type": "ImageObject",
        url: "https://plugmonkey.xyz/brand/plugmonkey-logo.png",
      },
    },
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: breadcrumbs.map((crumb, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: crumb.name,
      item: crumb.url,
    })),
  };

  const faqSchema = faq
    ? faqToFAQPageSchema(faq as unknown as GeneralFAQItem[], {
        url,
        name: `${name} FAQ`,
        description: `Frequently asked questions about ${name}.`,
      })
    : null;

  return (
    <>
      <Script
        id="webpage-schema"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }}
      />
      <Script
        id="breadcrumb-schema"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
      {faqSchema && (
        <Script
          id="faq-schema"
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
        />
      )}
    </>
  );
}
